/** Label and text color for each `partnerships.status`. */
export const PARTNERSHIP_STATUS = {
    PENDING: { label: 'Invite pending', className: 'text-warning' },
    APPROVED: { label: 'Connected', className: 'text-primary' },
    DENIED: { label: 'Not connected', className: '' },
};

/** Shown when a partnership has a status not in `PARTNERSHIP_STATUS`. */
export const UNKNOWN_PARTNERSHIP_STATUS = { label: 'Status unknown', className: '' };

/**
 * Setup state of a connection with a shipper, with its label and text color. Override statuses map
 * the way the corporate Integrations card reads them: COMPLETE is ENABLED, PENDING is PENDING, and
 * ERROR or no status is ERROR.
 */
export const SETUP_STATE = {
    ENABLED: { key: 'ENABLED', label: 'Enabled', className: 'text-primary' },
    PENDING: { key: 'PENDING', label: 'Pending', className: 'text-warning' },
    ERROR: { key: 'ERROR', label: 'Error', className: 'text-destructive' },
    DISABLED: { key: 'DISABLED', label: 'Disabled', className: '' },
};

/** Shown for a setup line while the status is loading, or when it couldn't be read. */
export const UNKNOWN_SETUP_STATE = { label: '—', className: 'text-muted' };

/** Order and labels of the setup lines on each shipper row. Keys match `getSetupStatusByShipper`. */
export const SETUP_TYPES = [
    { key: 'webhook', label: 'Webhook' },
    { key: 'edi', label: 'EDI' },
    { key: 'integrations', label: 'Integrations' },
];

/**
 * `integration_overrides` types configured on the shipper alone (not with a carrier), so they
 * don't count as a carrier integration. Matches SHIPPER_SCOPED_OVERRIDE_TYPES in CorporateUsers.
 */
export const SHIPPER_SCOPED_OVERRIDE_TYPES = ['PC_MILER'];

/**
 * `integration_overrides` types that are only a placeholder for a connection (created by Connect
 * Shipper / Connect Carrier) until an integration is set up, so they don't count. Matches the
 * corporate Integrations card (ShipperSection.js).
 */
export const PLACEHOLDER_OVERRIDE_TYPES = ['MANUAL'];

/** Tabs on a shipper's profile, in display order. `value` is the tab key. */
export const PROFILE_TABS = [
    { value: 'details', label: 'Details' },
    { value: 'surveys', label: 'Surveys' },
    { value: 'communication', label: 'Communication' },
    { value: 'skus', label: 'SKUs' },
    { value: 'sla-requirements', label: 'SLA Requirements' },
    { value: 'billing', label: 'Billing / Tariffs' },
];

/** Circles flag on the shipper's user for the order-completed email. */
export const ORDER_COMPLETED_EMAIL_FLAG = 'tms-order-completed-email';
